import * as React from 'react'
import { styled, useTheme } from '@mui/material/styles'
import { Button, Typography, Tooltip } from '@mui/material'
import { useLocation, useNavigate } from 'react-router-dom'

// Tipografía personalizada sincronizada con tema
const TypographyStyled = styled(Typography)(({ theme }) => ({
  fontFamily: theme.typography.fontFamily,
  fontStyle: 'normal',
  position: 'relative',
  fontSize: '0.875em',
  fontWeight: 650,
  color: theme.palette.text.white,
  transition: 'color 0.7s ease, text-decoration 0.5s ease',
}))

// Botón base personalizado con estilo limpio
const ButtonCustom = styled(Button)(({ theme }) => ({
  px: 2,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: theme.shape.borderRadius,
  backgroundColor: 'transparent',
  textTransform: 'uppercase',
  transition: 'color 0.7s ease, text-decoration 0.5s ease',
}))

const TooltipMain = ({ id, to, text, icon, onClick, ishovered }) => {
  const theme = useTheme()
  const navigate = useNavigate()
  const location = useLocation()

  const normalizePath = path => (path || '').replace(/\/+$/, '')
  const isActive = Boolean(to) && normalizePath(location.pathname) === normalizePath(to)

  const activeStyle = {
    textDecoration: 'none',
    ...(ishovered
      ? { borderBottom: `2px solid transparent` }
      : { borderBottom: `2px solid ${theme.palette.secondary.light}` }),
  }

  const inactiveStyle = {
    textDecoration: 'none',
    borderBottom: 'none',
  }

  const handleClick = event => {
    if (onClick) {
      onClick(event)
      return
    }

    if (to && !isActive) {
      navigate(to)
    }
  }

  return (
    <Tooltip title={text} placement="bottom-start">
      <ButtonCustom id={id} startIcon={icon} onClick={handleClick}>
        <TypographyStyled style={isActive || ishovered ? activeStyle : inactiveStyle}>
          {text}
        </TypographyStyled>
      </ButtonCustom>
    </Tooltip>
  )
}

export default TooltipMain
